export const TABLE_PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

export enum TABLE_DATA_TYPE {
    TEXT = 'text',
    TEXT_ASYNC = 'textAsync',
    STATUS = 'status',
    MULTILINE = 'multiline',
    SUPERSCRIPT = 'superscript',
    IMAGE = 'image',
    EVENT = 'event',
    LIST = 'list',
    TEMPLATE = 'template',
}

export enum TABLE_COLUMN_ALIGNMENT {
    LEFT = 'left',
    RIGHT = 'right',
    CENTER = 'center',
}
